export class Padding {
  Desktop: Paddings = new Paddings();
  Tablet: Paddings = new Paddings();
  Mobile: Paddings = new Paddings();
  Changed: boolean = false;
}

export class Paddings {
  Top?: string;
  Left?: string;
  Bottom?: string;
  Right?: string;
}
